
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_uv3x4_141",
  "slider-side": "awsui_slider-side_cqzlk_uv3x4_175",
  "slider-side-start": "awsui_slider-side-start_cqzlk_uv3x4_176"
};
  